import requests from 'api/index';

const prefixURL = '/portal';

export default {
  getEncodeUserToken: () => requests.get(`${prefixURL}/user/rest/v1/getEncodeUsertoken`),
};
